<section class="dashboard_content_sec">
  <div class="dashboard_bred_crumb">
    <ul>
      <li>
        <a [routerLink]="['/profile/job-listing']" routerLinkActive="active-link">
          Home
        </a>
      </li>
      <li><img src="../../../../../assets/images/icons/bred_crumb_arrow.svg" alt=""></li>

      <li>
        <a [routerLink]="['/profile/job-listing']" routerLinkActive="active-link">
          Job Corner
        </a>
      </li>
      <li><img src="../../../../../assets/images/icons/bred_crumb_arrow.svg" alt=""></li>

      <li>
        <a [routerLink]="['/profile/job-post']" routerLinkActive="active-link">
          Create new Job
        </a>
      </li>
    </ul>
  </div>

  <section class="master_add_sec">
    <div>{{showMessage}}</div>
    <form class="form-section" [formGroup]="jobPostForm" #postFormClear="ngForm">

      <div class="jobSelectTheList">
        <div class="section-header" style="margin-bottom: 16px;">
          <span class="section-title" style="width: 81px; height: 30px;">Job Info</span>
        </div>
        <div class="" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
          fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="25px">
          <div fxLayout="column" fxFlex="50" fxFlexFill class="addform-50-column">

            <!-- Job Title -->
            <div fxLayout="column" fxFlex="50" fxFlexFill class="addform-50-column">

              <div class="custom-form-group">
                <label class="custom-label" for="">Job Title<span class="star"
                    style="display: inline-block !important;">*</span></label>
                <div class="custom-form-control">
                  <mat-form-field appearance="outline" class="rounded-form-field">
                    <input matInput placeholder="Enter Job Title" name="jobtitle" formControlName="jobtitle" />
                  </mat-form-field>
                </div>
              </div>

            </div>

            <!-- SELECT Role-->
            <div class="custom-form-group">
              <label class="custom-label" for="erole">
                Role<span class="star">*</span>
              </label>
              <div class="custom-form-control">
                <mat-form-field appearance="outline" class="custom-mat-select">
                  <mat-select placeholder="Select any type" id="erole" name="erole" formControlName="erole">

                    <mat-option disabled>Select Role</mat-option>
                    <mat-option *ngFor="let role of roles" [value]="role.role_name">
                      {{ role.role_name }}
                    </mat-option>
                  </mat-select>

                  <!-- Custom caret icon -->
                  <img src="assets/images2/CaretDown.svg" class="custom-caret-icon" alt="Arrow" />
                </mat-form-field>
              </div>
            </div>

          </div>
          <div fxLayout="column" fxFlex="50" fxFlexFill class="addform-50-column">
            <!-- Company Name-->
            <div fxLayout="column" fxFlex="50" fxFlexFill class="addform-50-column">

              <div class="custom-form-group">
                <label class="custom-label" for="">Company Name<span class="star"
                    style="display: inline-block !important;">*</span></label>
                <div class="custom-form-control">
                  <mat-form-field appearance="outline">
                    <input matInput placeholder="Enter Company Name" name="ecompanyname" formControlName="ecompanyname"
                      readonly />
                  </mat-form-field>
                </div>
              </div>

            </div>

            <!-- SELECT Type of Employment-->
            <div class="custom-form-group">
              <label class="custom-label" for="">Type of Employment<span class="star"
                  style="display: inline-block !important;">*</span></label>
              <div class="custom-form-control">
                <!-- <mat-form-field appearance="outline">
                  <mat-select placeholder="Select any type" multiple name="typeofemp" formControlName="typeofemp"
                    (selectionChange)="onTypeOfEmpChange()">
                    <mat-option *ngFor="let EmployeeType of EmployeeType" [value]="EmployeeType.employee_type_name">
                      {{ EmployeeType.employee_type_name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field> -->
                <mat-form-field appearance="outline" class="custom-mat-select">
                  <mat-select placeholder="Select any type" multiple name="typeofemp" formControlName="typeofemp"
                    (selectionChange)="onTypeOfEmpChange()">

                    <mat-option *ngFor="let EmployeeType of EmployeeType" [value]="EmployeeType.employee_type_name">
                      {{ EmployeeType.employee_type_name }}
                    </mat-option>
                  </mat-select>

                  <!-- Custom caret image -->
                  <img src="assets/images2/CaretDown.svg" class="custom-caret-icon" alt="Arrow" />
                </mat-form-field>

                <div *ngIf="showLocumInput">
                  <mat-form-field appearance="outline"
                    [ngClass]="{ 'mat-form-field-invalid': showLocumInput && jobPostForm.get('availability')?.invalid && jobPostForm.get('availability')?.touched }">
                    <input matInput readonly placeholder="Select Locum Availability Dates" [value]="getLocumSummary()"
                      (click)="openCalendarPopup = true" (blur)="jobPostForm.get('availability')?.markAsTouched()" />
                    <button mat-icon-button matSuffix tabindex="-1" type="button" (click)="openCalendarPopup = true">
                      <mat-icon>calendar_today</mat-icon>
                    </button>
                  </mat-form-field>


                  <div class="popup-container" *ngIf="openCalendarPopup" (click)="$event.stopPropagation()">
                    <div class="popup-header">
                      <span style="padding: 12px;">Select Locum Dates</span>
                      <button mat-icon-button color="warn" type="button"
                        (click)="openCalendarPopup=false; $event.stopPropagation()"><mat-icon>close</mat-icon></button>
                    </div>

                    <div class="popup-body">
                      <div class="date-range-pickers">
                        <mat-form-field appearance="outline" class="range-field">
                          <input readonly matInput [matDatepicker]="startPicker" placeholder="Start Date"
                            [value]="startDate" [matDatepickerFilter]="dateFilter"
                            (dateChange)="onStartDateChange($event.value)" [max]="endDate">
                          <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
                          <mat-datepicker #startPicker></mat-datepicker>
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="range-field">
                          <input readonly matInput [matDatepicker]="endPicker" placeholder="End Date" [value]="endDate"
                            [matDatepickerFilter]="dateFilter" (dateChange)="onEndDateChange($event.value)"
                            [min]="startDate">
                          <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
                          <mat-datepicker #endPicker></mat-datepicker>
                        </mat-form-field>
                      </div>

                      <div class="popup-actions">
                        <button mat-raised-button (click)="saveDateRange()" type="button"
                          style="background: #ff7000; color: #fff;">Save</button>
                        <button mat-raised-button color="warn" (click)="clearDateRange()" type="button">Clear</button>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Employment Type  ends-->
              </div>
            </div>

          </div>
        </div>
      </div>

      <!-- Job  -->
      <div class="jobSelectTheList">
        <!-- Section Header -->
        <div class="section-header" style="margin-bottom: 16px;">
          <span class="section-title" style="width: 129px;">Job Location</span>
        </div>

        <div fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row" fxLayout.xs="column"
          fxLayoutAlign="start stretch" fxLayoutGap="25px">

          <!-- Left Column -->
          <div fxLayout="column" fxFlex="50" fxFlexFill class="addform-50-column">
            <!-- Search Location -->
            <div fxLayout="column" fxFlex="50" fxFlexFill class="addform-50-column">
              <div class="custom-form-group">
                <label class="custom-label">Search Location <span class="star"
                    style="display: inline-block !important;">*</span></label>
                <div class="custom-form-control">
                  <mat-form-field appearance="outline">
                    <input type="text" matInput placeholder="Search Location" autocorrect="off" autocapitalize="off"
                      spellcheck="off" name="elocation" formControlName="elocation" #search />
                  </mat-form-field>
                </div>
              </div>
            </div>

            <!-- State -->
            <div fxLayout="column" fxFlex="50" fxFlexFill class="addform-50-column">
              <div class="custom-form-group">
                <label class="custom-label">State <span class="star"
                    style="display: inline-block !important;">*</span></label>
                <div class="custom-form-control">
                  <mat-form-field appearance="outline">
                    <input matInput placeholder="Enter State" name="empstate" formControlName="empstate" />
                  </mat-form-field>
                </div>
              </div>
            </div>


          </div>

          <!-- Right Column -->
          <div fxLayout="column" fxFlex="50" fxFlexFill class="addform-50-column">



            <!-- Country -->
            <div class="custom-form-group">
              <label class="custom-label">Country <span class="star"
                  style="display: inline-block !important;">*</span></label>
              <div class="custom-form-control">
                <mat-form-field appearance="outline">
                  <input matInput placeholder="Enter Country" name="ecountry" formControlName="ecountry" />
                </mat-form-field>
              </div>
            </div>

            <!-- City/Post Code -->
            <div class="custom-form-group">
              <label class="custom-label">City/ Post code <span class="star"
                  style="display: inline-block !important;">*</span></label>
              <div class="custom-form-control">
                <mat-form-field appearance="outline">
                  <input matInput placeholder="Enter City/ Post code" name="epostalcode"
                    formControlName="epostalcode" />
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
      </div>



      <!-- Logo and Banner -->
      <div class="jobSelectTheList">
        <div class="section-header" style="margin-bottom: 16px;">
          <span class="section-title" style="width: 146px;
        ">Logo & Banner</span>
        </div>

        <!-- Row 1: Logo & Banner -->
        <div fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row" fxLayout.xs="column"
          fxLayoutAlign="start stretch" fxLayoutGap="25px">
          <!-- Logo Upload -->
          <div fxLayout="column" fxFlex="50" fxFlexFill class="addform-50-column">
            <div class="custom-form-group">
              <label class="custom-label" for="">Logo<span class="star"
                  style="display: inline-block !important;">*</span></label>
              <div class="custom-form-control">
                <div class="upload-card">
                  <div *ngIf="loginDetails?.logo?.url || directorylogoUrl; else logoUploader">
                    <div class="uploaded_img">
                      <ul>
                        <li>
                          <img class="preview_imgs" [src]="loginDetails?.logo?.url || directorylogoUrl" />
                        </li>
                      </ul>
                    </div>
                  </div>
                  <ng-template #logoUploader>
                    <div class="dropzone">
                      <img class="upload-icon" src="assets/images2/Featured-icon.svg" alt="" />
                      <p class="upload-text">Choose a file or drag & drop it here.</p>
                      <p class="upload-subtext">JPEG, PNG formats, up to 5 MB</p>
                      <label class="upload-btn">
                        <input type="file" hidden (change)="onSelectThumbnailImage($event.target.files,'logo')"
                          name="elogo" formControlName="elogo" />
                        Browse File
                      </label>
                    </div>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>

          <!-- Banner Upload -->
          <div fxLayout="column" fxFlex="50" fxFlexFill class="addform-50-column">
            <div class="custom-form-group">
              <label class="custom-label" for="">Banner

                <!-- <span class="star" style="display: inline-block !important;">*</span > -->
              </label>
              <div class="custom-form-control">
                <div class="upload-card">
                  <div *ngIf="bannerImage; else bannerUploader">
                    <div class="uploaded_img">
                      <ul>
                        <li>
                          <img class="preview_img" [src]="bannerImage?.url" alt="" />
                          <button mat-icon-button class="close-icon-btn" (click)="removeImg('banner')">
                            <mat-icon>close</mat-icon>
                          </button>

                        </li>
                      </ul>
                    </div>
                  </div>
                  <ng-template #bannerUploader>
                    <div class="dropzone">
                      <img class="upload-icon" src="assets/images2/Featured-icon.svg" alt="" />
                      <p class="upload-text">Choose a file or drag & drop it here.</p>
                      <p class="upload-subtext">JPEG, PNG formats, up to 5 MB</p>
                      <label class="upload-btn">
                        <input type="file" hidden (change)="onSelectThumbnailImage(fileVableBanner.files,'banner')"
                          #fileVableBanner (click)="$event.stopPropagation()" name="ebanner"
                          formControlName="ebanner" />
                        Browse File
                      </label>
                    </div>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Row 2: Clinic Photo -->
        <div fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row" fxLayout.xs="column"
          fxLayoutAlign="start stretch" style="margin-top: 20px">
          <div fxLayout="column" fxFlex="100" fxFlexFill class="addform-50-column">
            <div class="custom-form-group">
              <label class="custom-label">Clinic Photo</label>
              <div class="custom-form-control">
                <div class="master_uploader">
                  <!-- Wrap entire uploader in a label -->
                  <label class="img_uploader" for="clinicFileInput">
                    <p>Upload Photo</p>
                    <img src="assets/images/icons/file.svg" />
                    <!-- Hidden file input -->
                    <input id="clinicFileInput" type="file" class="file_input" accept="image/*,video/*" multiple
                      (change)="onSelectThumbnailImage(fileVableclinic.files, 'clinic')" #fileVableclinic
                      (click)="$event.stopPropagation()" name="clinicphoto" formControlName="clinicphoto"
                      style="display: none;" />
                  </label>

                  <!-- Preview Uploaded Images/Videos -->
                  <div class="uploaded_img" *ngIf="clinicImages.length">
                    <ul class="horizontal-list">
                      <li *ngFor="let media of clinicImages; let i = index">
                        <ng-container [ngSwitch]="media.type">
                          <img *ngSwitchCase="'image'" class="preview_img" [src]="media.url" alt="Image" />
                          <video *ngSwitchCase="'video'" class="preview_img" [src]="media.url" controls></video>
                        </ng-container>
                        <div class="close_img">
                          <img src="assets/images/icons/close.svg" (click)="removeImg('clinic', i)" alt="Remove" />
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
        <!-- <div class="" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
        fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="25px">
        <div fxLayout="column" fxFlex="50" fxFlexFill class="addform-50-column">
           Clinic Photo
          <div class="custom-form-group mb-15">
            <label class="custom-label" for="">Clinic Photo</label>
            <div class="custom-form-control">
              <div class="master_uploader">
                <div class="img_uploader">
                  <p>Upload Photo</p>
                  <img src="../../../../../../../assets/images/icons/file.svg">
                  <input type="file" class="file_input" accept="image/*,video/*" multiple
                    (change)="onSelectThumbnailImage(fileVableclinic.files, 'clinic')" #fileVableclinic
                    (click)="$event.stopPropagation()" name="clinicphoto" formControlName="clinicphoto">
                </div>

                <div class="uploaded_img" *ngIf="clinicImages.length">
                  <ul class="horizontal-list">
                    <li *ngFor="let media of clinicImages; let i = index">
                      <ng-container [ngSwitch]="media.type">
                        <img *ngSwitchCase="'image'" class="preview_img" [src]="media.url" alt="Image">
                        <video *ngSwitchCase="'video'" class="preview_img" [src]="media.url" controls></video>
                      </ng-container>
                      <div class="close_img">
                        <img src="../../../../../assets/images/icons/close.svg" (click)="removeImg('clinic',i)"
                          alt="Remove">
                      </div>
                    </li>
                  </ul>
                </div>

              </div>
            </div>
          </div>

        </div>
      </div> -->
      </div>





      <!-- Other Info -->
      <div class="jobSelectTheList">
        <!-- Section Header -->
        <div class="section-header" style="margin-bottom: 16px;">
          <span class="section-title" style="width: 99px;">Other Info</span>
        </div>

        <!-- Main Row with Two Columns -->
        <div fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row" fxLayout.xs="column"
          fxLayoutAlign="start stretch" fxLayoutGap="25px">

          <!-- Left Column -->
          <div fxLayout="column" fxFlex="50" fxFlexFill class="addform-50-column">

            <!-- Start Date -->
            <div class="custom-form-group supplies_add_form">
              <label class="custom-label" for="">
                Choose a start date to publish your job ?
                <span class="star">*</span>
              </label>
              <div class="custom-form-control featured_toggle" style="gap: 20px !important;">
                <div class="custom-tabs">
                  <mat-button-toggle-group name="postpalnning" formControlName="postpalnning"
                    (change)="getPostPlanningAction($event)">
                    <mat-button-toggle value="YES"> Yes </mat-button-toggle>
                    <mat-button-toggle value="NO"> No </mat-button-toggle>
                  </mat-button-toggle-group>
                </div>

                <ng-container *ngIf="showTypeDt">
                  <div class="custom-form-control" style="width: 100%; position: relative;">
                    <mat-form-field appearance="outline" style="width: 100%; margin: 0 !important;" floatLabel="never">
                      <mat-icon matPrefix class="custom-calendar-icon">calendar_today</mat-icon>
                      <input matInput [matDatepicker]="startDatePicker" name="planningdate"
                        formControlName="planningdate" placeholder="Select Date" (click)="startDatePicker.open()" />
                      <mat-datepicker #startDatePicker></mat-datepicker>
                    </mat-form-field>

                    <img src="assets/images2/CaretDown.svg" class="custom-caret-icon" alt="Arrow"
                      (click)="startDatePicker.open()" />
                  </div>
                </ng-container>
              </div>
            </div>




            <!-- How quickly to Hire -->
            <div class="custom-form-group">
              <label class="custom-label">How quickly to Hire<span class="star">*</span></label>
              <div class="custom-form-control">
                <mat-form-field appearance="outline" style="width: 100%;" class="custom-mat-select">
                  <mat-select placeholder="Select Hire quickly" name="ehirequick" formControlName="ehirequick">
                    <mat-option disabled>Select</mat-option>
                    <mat-option value="urgently">Urgently</mat-option>
                    <mat-option value="1-2 weeks">1-2 weeks</mat-option>
                    <mat-option value="2-4 weeks">2-4 weeks</mat-option>
                    <mat-option value="More than 4 weeks">More than 4 weeks</mat-option>
                  </mat-select>
                  <img src="assets/images2/CaretDown.svg" class="custom-caret-icon" alt="Arrow" />
                </mat-form-field>
              </div>
            </div>




            <!-- Experience -->
            <div class="custom-form-group">
              <label class="custom-label">Experience<span class="star">*</span></label>
              <div class="custom-form-control">
                <mat-form-field appearance="outline" style="width: 100%;" class="custom-mat-select">
                  <mat-select placeholder="Select Experience" formControlName="experience" name="experience">
                    <mat-option value="0">0</mat-option>
                    <mat-option value="1-2">1-2</mat-option>
                    <mat-option value="3-5">3-5</mat-option>
                    <mat-option value="5-10">5-10</mat-option>
                    <mat-option value="10-15">10-15</mat-option>
                    <mat-option value="15-20">15-20</mat-option>
                    <mat-option value="20-25">20-25</mat-option>
                    <mat-option value="25-30">25-30</mat-option>
                    <mat-option value="30-35">30-35</mat-option>
                    <mat-option value="35-40">35-40</mat-option>
                    <mat-option value="40+">40+</mat-option>
                  </mat-select>
                  <img src="assets/images2/CaretDown.svg" class="custom-caret-icon" alt="Arrow" />
                </mat-form-field>
              </div>
            </div>

            <!--  Added: Benefits -->
            <div class="custom-form-group">
              <label class="custom-label">
                Do you offer any of the following benefits? <span class="star"
                  style="display: inline-block !important;">*</span>
              </label>
              <div class="custom-form-control">
                <mat-form-field appearance="outline" class="custom-mat-select" style="width: 100%;">
                  <mat-select placeholder="Select" multiple name="eoffierbenefits" formControlName="eoffierbenefits">
                    <mat-option disabled>Select</mat-option>
                    <mat-option value="Performance bonus">Performance bonus</mat-option>
                    <mat-option value="Commission">Commission</mat-option>
                    <mat-option value="relcation fees">Relocation fees</mat-option>
                    <mat-option value="Tips">Tips</mat-option>
                    <mat-option value="Overtime pay">Overtime pay</mat-option>
                    <mat-option value="signing Bonus">Signing Bonus</mat-option>
                    <mat-option value="Bonus">Bonus</mat-option>
                    <mat-option value="Annual Bonus">Annual Bonus</mat-option>
                    <mat-option value="Quarterly bonus">Quarterly bonus</mat-option>
                    <mat-option value="Employee Discount">Employee Discount</mat-option>
                    <mat-option value="Visa sponsorship">Visa sponsorship</mat-option>
                    <mat-option value="Employee Mentoring progrom">Employee Mentoring program</mat-option>
                    <mat-option value="Professional Development assistance">Professional Development
                      assistance</mat-option>
                    <mat-option value="Company car">Company car</mat-option>
                    <mat-option value="Travel reimbursement">Travel reimbursement</mat-option>
                    <mat-option value="Housing allowance">Housing allowance</mat-option>
                    <mat-option value="other">Other</mat-option>
                  </mat-select>
                  <img src="assets/images2/CaretDown.svg" class="custom-caret-icon" alt="Arrow" />
                </mat-form-field>
              </div>

              <!-- <div class="" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
        fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="25px">
        <div fxLayout="column" fxFlex="50" fxFlexFill class="addform-50-column">
          <div class="custom-form-group">
            <label class="custom-label" for="">Do you offer any of the following benefits? <span class="star"
                style="display: inline-block !important;">*</span></label>
            <div class="custom-form-control">
              <mat-form-field appearance="outline"  class="custom-mat-select">
                <mat-select placeholder="Select" multiple name="eoffierbenefits" formControlName="eoffierbenefits">
                  <mat-option disabled=""> Select</mat-option>
                  <mat-option value="Performance bonus">Performance bonus</mat-option>
                  <mat-option value="Commission">Commission</mat-option>
                  <mat-option value="relcation fees">relocation fees </mat-option>
                  <mat-option value="Tips">Tips</mat-option>
                  <mat-option value="Overtime pay">Overtime pay</mat-option>
                  <mat-option value="signing Bonus">signing Bonus</mat-option>
                  <mat-option value="Bonus">Bonus </mat-option>
                  <mat-option value="Annual Bonus">Annual Bonus</mat-option>
                  <mat-option value="Quarterly bonus">Quarterly bonus</mat-option>
                  <mat-option value="Employee Discount">Employee Discount</mat-option>
                  <mat-option value="Visa sponsorship">Visa sponsorship</mat-option>
                  <mat-option value="Employee Mentoring progrom">Employee Mentoring progrom </mat-option>
                  <mat-option value="Professional Development assistance">Professional Development
                    assistance</mat-option>
                  <mat-option value="Company car">Company car</mat-option>
                  <mat-option value="Travel reimbursement">Travel reimbursement</mat-option>
                  <mat-option value="Housing allowance">Housing allowance</mat-option>
                  <mat-option value="other">other </mat-option>

                </mat-select>
                 Custom caret icon
                  <img src="assets/images2/CaretDown.svg" class="custom-caret-icon" alt="Arrow" />
              </mat-form-field>
            </div>
          </div>

        </div>

      </div> -->
            </div>

          </div>

          <!-- Right Column -->
          <div fxLayout="column" fxFlex="50" fxFlexFill class="addform-50-column">

            <!-- End Date -->
            <div class="custom-form-group supplies_add_form">
              <label class="custom-label">
                Choose an end date to unpublish your job <span class="star"
                  style="display: inline-block !important;">*</span>
              </label>
              <div class="custom-form-control featured_toggle" style="gap: 20px !important;">
                <div class="custom-tabs">
                  <mat-button-toggle-group name="endDateToggle" formControlName="endDateToggle"
                    (change)="getendDatePlanningAction($event)">
                    <mat-button-toggle value="YES">Yes</mat-button-toggle>
                    <mat-button-toggle value="NO">No</mat-button-toggle>
                  </mat-button-toggle-group>
                </div>
                <ng-container *ngIf="showTypeDt1">
                  <div class="custom-form-control" style="width: 100%; position: relative;">
                    <mat-form-field appearance="outline" style="width: 100%; margin: 0 !important;" floatLabel="never">
                      <mat-icon matPrefix class="custom-calendar-icon">calendar_today</mat-icon>
                      <input matInput [matDatepicker]="endDatePicker" formControlName="endDate"
                        placeholder="Select Date" (click)="endDatePicker.open()" />
                      <mat-datepicker #endDatePicker></mat-datepicker>
                    </mat-form-field>
                    <img src="assets/images2/CaretDown.svg" class="custom-datepicker-icon" alt="Open Calendar"
                      (click)="endDatePicker.open()" />
                  </div>
                </ng-container>
              </div>
            </div>



            <!-- No. of Positions -->
            <div class="custom-form-group">
              <label class="custom-label">No of Positions<span class="star">*</span></label>
              <div class="custom-form-control">
                <mat-form-field appearance="outline" style="width: 100%;" class="custom-mat-select">
                  <mat-select placeholder="Select number" name="enopeople" formControlName="enopeople">
                    <mat-option disabled>Select</mat-option>
                    <mat-option value="1">1</mat-option>
                    <mat-option value="2">2</mat-option>
                    <mat-option value="3">3</mat-option>
                    <mat-option value="4">4</mat-option>
                    <mat-option value="5">5</mat-option>
                    <mat-option value="6+">6+</mat-option>
                  </mat-select>
                  <img src="assets/images2/CaretDown.svg" class="custom-caret-icon" alt="Arrow" />
                </mat-form-field>
              </div>
            </div>

            <!-- Education -->
            <!-- Education -->
            <div class="custom-form-group" style="width: 100%;">
              <label class="custom-label" for="education">
                Education level<span class="star">*</span>
              </label>
              <div class="custom-form-control">
                <textarea id="education" name="education" formControlName="education" placeholder="Enter education"
                  class="education-level"></textarea>
              </div>
            </div>






          </div>
        </div>
        <!-- <div class="jobSelectTheList" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
        fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="25px">

        <div fxLayout="column" fxFlex="100" fxFlexFill class="addform-50-column">
          <div class="" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
            fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="25px">
            <div fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="column"
              fxLayout.xs="column" fxFlex="50" fxFlexFill class="addform-50-column">
              Planned start date

              <div class="custom-form-group supplies_add_form">
                <label class="custom-label" for=""> Choose a start date to publish your job ?<span
                    class="star">*</span></label>
                <div class="custom-form-control featured_toggle" style="gap: 20px !important;">
                  <div class="custom-tabs">
                    <mat-button-toggle-group name="postpalnning" formControlName="postpalnning"
                      (change)="getPostPlanningAction($event)">
                      <mat-button-toggle value="YES"> Yes </mat-button-toggle>
                      <mat-button-toggle value="NO"> No </mat-button-toggle>

                    </mat-button-toggle-group>
                   

                  </div>

                  <ng-container *ngIf="showTypeDt">
                    <div fxLayout="column" fxFlex="50" fxFlexFill class="addform-50-column">
                      <div>
                        <div class="custom-form-control">
                          <mat-form-field appearance="outline" style="margin: 0px !important;">

                            <input matInput [matDatepicker]="picker" name="planningdate" formControlName="planningdate"
                              placeholder="Select Date">

                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>

              </div>

            </div>

            <div fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="column"
              fxLayout.xs="column" fxFlex="50" fxFlexFill class="addform-50-column">
              End Date Toggle
              <div class="custom-form-group supplies_add_form">
                <label class="custom-label">
                  Choose an end date to unpublish your job <span class="star"
                    style="display: inline-block !important;">*</span>
                </label>
                <div class="custom-form-control featured_toggle" style="gap: 20px !important;">
                  <div class="custom-tabs">
                    <mat-button-toggle-group name="endDateToggle" formControlName="endDateToggle"
                      (change)="getendDatePlanningAction($event)">
                      <mat-button-toggle value="YES">Yes</mat-button-toggle>
                      <mat-button-toggle value="NO">No</mat-button-toggle>
                    </mat-button-toggle-group>
                  </div>

                  <ng-container *ngIf="showTypeDt1">
                    <div fxLayout="column" fxFlex="50" fxFlexFill class="addform-50-column">
                      <div class="custom-form-control">
                        <mat-form-field appearance="outline" floatLabel="always"
                          style="width: 100%;margin: 0px !important;">
                          <mat-label>Select End Date</mat-label>
                          <input matInput [matDatepicker]="picker" formControlName="endDate"
                            placeholder="Select Date" />
                          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                          <mat-datepicker #picker></mat-datepicker>
                        </mat-form-field>
                      </div>
                    </div>
                  </ng-container>

                </div>
              </div>

              End Date Picker

            </div>


          </div>
        </div>
      </div> -->
      </div>




      <!-- Pay details -->

      <div class="jobSelectTheList">
        <!-- Section Header -->
        <div class="section-header" style="margin-bottom: 16px;">
          <span class="section-title" style="width: 112px;">Pay Details</span>
        </div>

        <!-- Main Row Container (Pay/Rate + Min/Max) -->
        <div fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row" fxLayout.xs="column"
          fxLayoutAlign="start stretch" fxLayoutGap="25px">

          <!-- Left Column: Pay + Minimum -->
          <div fxLayout="column" fxFlex="50" fxFlexFill class="addform-50-column">

            <!-- Pay -->
            <div fxLayout="column" fxFlexFill class="addform-50-column">
              <div class="custom-form-group">
                <label class="custom-label">Pay <span class="star"
                    style="display: inline-block !important;">*</span></label>
                <div class="custom-form-control">
                  <mat-form-field appearance="outline" class="custom-mat-select">
                    <mat-select placeholder="Range" name="erange" formControlName="erange">
                      <mat-option disabled>Select</mat-option>
                      <mat-option value="Range">Range</mat-option>
                    </mat-select>

                    <!-- Custom caret icon -->
                    <img src="assets/images2/CaretDown.svg" class="custom-caret-icon" alt="Arrow" />
                  </mat-form-field>
                </div>
              </div>
            </div>

            <!-- Minimum -->
            <div class="custom-form-group">
              <label class="custom-label">Minimum <span class="star"
                  style="display: inline-block !important;">*</span></label>
              <div class="custom-form-control">
                <mat-form-field appearance="outline">
                  <input matInput placeholder="Minimum" name="erangemin" formControlName="erangemin" />
                </mat-form-field>
              </div>
            </div>
          </div>

          <!-- Right Column: Rate + Maximum -->
          <div fxLayout="column" fxFlex="50" fxFlexFill class="addform-50-column">

            <!-- Rate -->
            <div fxLayout="column" fxFlexFill class="addform-50-column">
              <div class="custom-form-group">
                <label class="custom-label">Rate <span class="star"
                    style="display: inline-block !important;">*</span></label>
                <div class="custom-form-control">
                  <mat-form-field appearance="outline" class="custom-mat-select">
                    <mat-select placeholder="Select Rate" name="ebilling" formControlName="ebilling">
                      <mat-option disabled>Select</mat-option>
                      <mat-option value="Per year">Per year</mat-option>
                      <mat-option value="Per month">Per month</mat-option>
                      <mat-option value="Per week">Per week</mat-option>
                      <mat-option value="Per hour">Per hour</mat-option>
                      <mat-option value="commission">Commission</mat-option>
                    </mat-select>

                    <!-- Custom caret icon -->
                    <img src="assets/images2/CaretDown.svg" class="custom-caret-icon" alt="Arrow" />
                  </mat-form-field>
                </div>
              </div>
            </div>

            <!-- Maximum -->
            <div class="custom-form-group">
              <label class="custom-label">Maximum <span class="star"
                  style="display: inline-block !important;">*</span></label>
              <div class="custom-form-control">
                <mat-form-field appearance="outline">
                  <input matInput placeholder="Maximum" name="erangemax" formControlName="erangemax" />
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- job Description -->

      <div class="jobSelectTheList" style="height: 243px;">
        <!-- Section Header -->
        <div class="section-header" style="margin-bottom: 18px;">
          <span class="section-title" style="width: 157px;">Job Description</span>
        </div>

        <!-- Job Description Input -->
        <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="25px"
          style="height: calc(243px - 100px);">
          <div fxFlexFill class="custom-form-group" style="display: flex; flex-direction: column; height: 100%;">

            <!-- Label -->
            <label class="custom-label" style="margin-bottom: 8px;">
              description
              <span class="star" style="display: inline-block !important;">*</span>
            </label>

            <!-- Wrapper that grows -->
            <div style="position: relative; flex: 1; display: flex; flex-direction: column;">
              <textarea placeholder="Enter Your Text Here" name="ejobdesp" formControlName="ejobdesp" maxlength="500"
                (input)="onJobDescChange($event)" class="description-textarea">
          </textarea>

              <!-- Character Counter -->
              <div style="
                        position: absolute;
                        bottom: 8px;
                        right: 4px;
                        font-size: 12px;
                        color: gray;
                        background: white;
                        padding: 0 4px;
                      ">
                {{ jobDescCharCount }} / 500
              </div>
            </div>
          </div>
        </div>




      </div>


      <!-- other links -->

      <div class="jobSelectTheList">
        <!-- Section Header -->
        <div class="section-header" style="margin-bottom: 16px;">
          <span class="section-title" style="width: 111px;">Other Links</span>
        </div>

        <!-- Row 1: Video Link & Website -->
        <div fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row" fxLayout.xs="column"
          fxLayoutAlign="start stretch" fxLayoutGap="25px">

          <!-- Video Link -->
          <div fxLayout="column" fxFlex="50" fxFlexFill class="addform-50-column">
            <div class="custom-form-group">
              <label class="custom-label" for="">Video Link</label>
              <div class="custom-form-control">
                <mat-form-field appearance="outline">
                  <input matInput placeholder="Video Link" name="videolink" formControlName="videolink" />
                </mat-form-field>
              </div>
            </div>
          </div>

          <!-- Website -->
          <div fxLayout="column" fxFlex="50" fxFlexFill class="addform-50-column">
            <div class="custom-form-group">
              <label class="custom-label" for="">Website</label>
              <div class="custom-form-control">
                <mat-form-field appearance="outline">
                  <input matInput placeholder="Website" name="website" formControlName="website" />
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>

        <!-- Row 2: Facebook, Instagram, LinkedIn -->
        <div fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row" fxLayout.xs="column"
          fxLayoutAlign="start stretch" fxLayoutGap="25px" style="margin-top: 16px;">

          <!-- Facebook -->
          <div fxLayout="column" fxFlex="33" fxFlexFill class="addform-50-column">
            <div class="custom-form-group">
              <label class="custom-label" for="">Facebook</label>
              <div class="custom-form-control">
                <mat-form-field appearance="outline">
                  <input matInput placeholder="Facebook" name="facebook" formControlName="facebook" />
                </mat-form-field>
              </div>
            </div>
          </div>

          <!-- Instagram -->
          <div fxLayout="column" fxFlex="33" fxFlexFill class="addform-50-column">
            <div class="custom-form-group">
              <label class="custom-label" for="">Instagram</label>
              <div class="custom-form-control">
                <mat-form-field appearance="outline">
                  <input matInput placeholder="Instagram" name="instagram" formControlName="instagram" />
                </mat-form-field>
              </div>
            </div>
          </div>

          <!-- LinkedIn -->
          <div fxLayout="column" fxFlex="33" fxFlexFill class="addform-50-column">
            <div class="custom-form-group">
              <label class="custom-label" for="">Linkedin</label>
              <div class="custom-form-control">
                <mat-form-field appearance="outline">
                  <input matInput placeholder="Linkedin" name="linkedin" formControlName="linkedin" />
                </mat-form-field>
              </div>
            </div>
          </div>

          <!-- <div class="" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
        fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="25px">
        <div fxLayout="column" fxFlex="50" fxFlexFill class="addform-50-column">
           Video Link
          <div class="custom-form-group">
            <label class="custom-label" for="">Video Link</label>
            <div class="custom-form-control">
              <mat-form-field appearance="outline">
                <input matInput placeholder="Video Link" name="videolink" formControlName="videolink" />
                <mat-error
                      *ngIf="seo_description.invalid && ( seo_description.dirty || seo_description.touched )">
                      <span>job description</span>
                    </mat-error>
              </mat-form-field>
            </div>
          </div>

        </div>
        <div fxLayout="column" fxFlex="50" fxFlexFill class="addform-50-column">
           Website
          <div class="custom-form-group">
            <label class="custom-label" for="">Website</label>
            <div class="custom-form-control">
              <mat-form-field appearance="outline">
                <input matInput placeholder="Website" name="website" formControlName="website" />
                <mat-error
                          *ngIf="seo_description.invalid && ( seo_description.dirty || seo_description.touched )">
                          <span>job description</span>
                        </mat-error>
              </mat-form-field>
            </div>
          </div>

        </div>
      </div> -->

          <!-- <div class="" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
        fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="25px">
        <div fxLayout="column" fxFlex="100" fxFlexFill>
           Facebook
          <div class="custom-form-group">
            <label class="custom-label" for="">Facebook</label>
            <div class="custom-form-control">
              <mat-form-field appearance="outline">
                <input matInput placeholder="Facebook" name="facebook" formControlName="facebook" />
                <mat-error
                      *ngIf="seo_description.invalid && ( seo_description.dirty || seo_description.touched )">
                      <span>job description</span>
                    </mat-error>
              </mat-form-field>
            </div>
          </div>

        </div>
        <div fxLayout="column" fxFlex="100" fxFlexFill>
           Instagram
          <div class="custom-form-group">
            <label class="custom-label" for="">Instagram</label>
            <div class="custom-form-control">
              <mat-form-field appearance="outline">
                <input matInput placeholder="Instagram" name="instagram" formControlName="instagram" />
                <mat-error
                          *ngIf="seo_description.invalid && ( seo_description.dirty || seo_description.touched )">
                          <span>job description</span>
                        </mat-error>
              </mat-form-field>
            </div>
          </div>

        </div>
        <div fxLayout="column" fxFlex="100" fxFlexFill>
           Linkedin
          <div class="custom-form-group">
            <label class="custom-label" for="">Linkedin </label>
            <div class="custom-form-control">
              <mat-form-field appearance="outline">
                <input matInput placeholder="Linkedin" name="linkedin" formControlName="linkedin" />
                <mat-error
                        *ngIf="seo_description.invalid && ( seo_description.dirty || seo_description.touched )">
                        <span>job description</span>
                      </mat-error>
              </mat-form-field>
            </div>
          </div>

        </div>
      </div> -->
        </div>
      </div>
      <div class="form_box">
        <div fxLayout="row wrap" fxLayoutAlign="space-between center" fxLayout.lt-md="column"
          fxLayoutAlign.lt-md="center center" style="height: 40px;">

          <!-- Left Group: Draft & Preview -->
          <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px" fxLayout.lt-md="column"
            fxLayoutAlign.lt-md="center center" class="button-group">
            <button type="button" class="btn btn-sm global-btn mat-button" mat-button fxFlex.lt-md
              (click)="postJob(postFormClear, 'DRAFT')">
              Save as Draft
            </button>

            <button type="button" class="btn btn-sm global-btn mat-button" mat-button fxFlex.lt-md
              (click)="openDialog()">
              Preview
            </button>
          </div>

          <!-- Right Group: Save & Cancel -->
          <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px" fxLayout.lt-md="column"
            fxLayoutAlign.lt-md="center center" class="button-group">
            <button type="submit" *ngIf="iseditMode" class="btn btn-sm global-btn mat-button" mat-button fxFlex.lt-md
              (click)="postJob(postFormClear, 'PENDING')">
              {{ iseditMode ? 'Update' : 'Save' }}
            </button>
            <button type="submit" *ngIf="!iseditMode && showCreateButton" class="btn btn-sm global-btn mat-button"
              mat-button fxFlex.lt-md (click)="postJob(postFormClear, 'PENDING')">
              {{ iseditMode ? 'Update' : 'Save' }}
            </button>

            <button type="button" class="btn btn-sm global-btn mat-button" mat-button fxFlex.lt-md
              [routerLink]="['/profile/job-listing']">
              Cancel
            </button>
          </div>

        </div>
      </div>
    </form>
  </section>
</section>